import React, { useState } from "react";
import SubmitBtn from "../submitButton";
import { requestPasswordReset } from "../../services/auth.service";

function RequestResetPwdForm({ setCurrentStep = () => {} }) {
  const [email, setEmail] = useState("");
  const [loading, setloading] = useState(false);
  const [errors, setErrors] = useState({ hasError: false, msg: "" });

  const handleSubmit = async (e) => {
    e.preventDefault();
    setloading(true);
    setErrors({ hasError: false, msg: "" });

    if (!email) {
      setErrors({
        hasError: true,
        msg: "Merci d'indiquer votre email",
      });
      setloading(false);
      return;
    }

    const res = await requestPasswordReset(email);
    // const res = { success: true, userId: 2 };

    if (res.success) {
      localStorage.setItem("userResetPwdRequestID", res.userId);
      setloading(false);
      setCurrentStep(2);
    } else {
      setErrors({
        hasError: true,
        msg: res.msg,
      });
      setloading(false);
    }
  };

  return (
    <form
      id="RequestResetPwdForm"
      className="form-group"
      onSubmit={handleSubmit}
      aria-busy={loading}
    >
      <div className="error-msg">{errors.hasError && <p>{errors.msg}</p>}</div>
      <div className="row">
        <label htmlFor="email">Email</label>
        <input
          type="email"
          name="email"
          id="email"
          className="form__input"
          autoComplete="email"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
        />
      </div>
      <SubmitBtn value="Envoyer le code" disabled={loading} />
      <a href="/login">{`< Retour à la connexion`}</a>
    </form>
  );
}

export default RequestResetPwdForm;
